export const normalizeConditionScore = (raw) => {
  let n = parseFloat(raw);
  if (!Number.isFinite(n)) return 0;
  if (n > 10) n = n / 10;
  if (n < 0) n = 0;
  if (n > 10) n = 10;
  return n;
};

const CONDITION_LABEL_SCORES = {
  NEW: 10,
  "LIKE-NEW": 9,
  LIKE_NEW: 9,
  EXCELLENT: 8,
  USED_EXCELLENT: 8,
  GOOD: 7,
  USED_GOOD: 7,
  FAIR: 6,
  USED_FAIR: 6,
  POOR: 0,
};

export const getConditionScoreFromLabel = (label) => {
  if (!label) return 0;
  const key = String(label).trim().toUpperCase().replace(/\s+/g, "_");
  if (CONDITION_LABEL_SCORES[key] != null) {
    return CONDITION_LABEL_SCORES[key];
  }
  const spacedKey = String(label).trim().toUpperCase().replace(/_/g, "-");
  return CONDITION_LABEL_SCORES[spacedKey] ?? 0;
};

export const resolveConditionScore = (score, conditionLabel) => {
  if (score != null && score !== "") {
    return normalizeConditionScore(score);
  }
  return getConditionScoreFromLabel(conditionLabel);
};

export const isConditionAcceptable = (conditionScore, minimumAcceptableCondition) => {
  const min = Number(minimumAcceptableCondition);
  if (!Number.isFinite(min) || min <= 0) return true;
  const score = normalizeConditionScore(conditionScore);
  return score >= min;
};
